
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface ItemCardProps {
  name: string;
  slug: string;
  type: 'category' | 'sport' | 'platform';
}

const ItemCard = ({ name, slug, type }: ItemCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow p-6 flex flex-col h-full">
      <h3 className="text-xl font-semibold mb-4">{name}</h3>
      <div className="mt-auto">
        <Button asChild className="w-full">
          <Link to={`/${type}/${slug}`}>
            Browse {name} Apps
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default ItemCard;
